import { atom } from "recoil";
import { ReportFilterType } from "../../../types";

export const reportFilter = atom<ReportFilterType>({
  key: "reportFilter",
  default: {
    companyId: null,
    serviceId: null,
    dateBeginFiltered: null,
    dateEndFiltered: null,
    momentRange: null,
  },
});

export const reportFilterModal = atom<boolean>({
  key: "reportFilterModal",
  default: false,
});
